import React, { useState } from "react";
import { POS_COLORS } from "../data/players";

/**
 * PlayerAvatar — the sleepercdn headshot with an initials-circle fallback.
 *
 * Extracted VERBATIM from PlayerList.jsx, where it was a local `MiniAvatar`.
 * PlayerList still renders it in both builder and auction modes; Draft Plan is
 * the second consumer, which is what earned it its own file.
 *
 * Three cases, in the order the branches test them:
 *   • a player with a sleeper_id that is not DEF → the CDN headshot, with an
 *     onError flip to the fallback (the id can be stale, or the CDN can simply
 *     not have that face)
 *   • DEF and K → the team abbreviation / initials, never a headshot: DEF has
 *     no person to show, and K headshots are mostly missing upstream
 *   • anyone else, or a failed image → a POS_COLORS circle with initials
 *
 * Colors are the original literals, not theme tokens, because this was a pure
 * move — restyling it would have changed both call sites in PlayerList at the
 * same time as relocating it, and those two risks do not belong in one commit.
 */
export default function PlayerAvatar({ player, size = 24 }) {
  const [err, setErr] = useState(false);
  const sid = player?.sleeper_id;
  const pos = player?.pos || "BN";
  const bg = POS_COLORS[pos]?.bg || "#64748b";
  if (sid && pos !== "DEF" && !err) {
    return <img src={`https://sleepercdn.com/content/nfl/players/${sid}.jpg`} alt="" onError={() => setErr(true)} style={{ width: size, height: size, borderRadius: "50%", objectFit: "cover", flexShrink: 0, background: "#0d1320" }} />;
  }
  const parts = (player?.name || "").split(" ");
  const label = pos === "DEF" || pos === "K" ? (player?.team || pos) : (parts.length >= 2 ? parts[0][0] + parts[parts.length - 1][0] : "?").toUpperCase();
  return <div style={{ width: size, height: size, borderRadius: "50%", flexShrink: 0, background: bg, display: "flex", alignItems: "center", justifyContent: "center", fontSize: pos === "DEF" || pos === "K" ? 8 : 9, fontWeight: 700, color: "#fff", lineHeight: 1 }}>{label}</div>;
}
